<template>
  <basic-container>
    <el-dialog
      title="制度类型管理"
      :visible.sync="openFlag"
      :modal-append-to-body="false"
      width="64%"
      @closed="handleClose"
      append-to-body
    >
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        :permission="permissionList"
        :before-open="beforeOpen"
        v-model="form"
        ref="crud"
        @row-update="rowUpdate"
        @row-save="rowSave"
        @row-del="rowDel"
        @search-change="searchChange"
        @search-reset="searchReset"
        @selection-change="selectionChange"
        @current-change="currentChange"
        @size-change="sizeChange"
        @on-load="onLoad"
        @refresh-change="onLoad"
      >
        <template slot="menuLeft">
          <el-button type="danger" size="small" icon="el-icon-delete" plain @click="handleDelete"
            >删 除
          </el-button>
        </template>
      </avue-crud>
    </el-dialog>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/clientserve/systemtype';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      openFlag: false,
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        indexLabel: '序号',
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        columnBtn: false,
        refreshBtn: false,
        searchMenuSpan: 6,
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: '排序号',
            prop: 'indexNum',
            maxlength: 8,
            showWordLimit: true,
            rules: [
              { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数' },
              {
                required: true,
                message: '请输入排序号',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '类型名称',
            prop: 'systemTypeName',
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入制度类型名称',
                trigger: 'blur',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    // permissionList() {
    //   return {
    //     addBtn: this.vaildData(this.permission.systemtype_add, false),
    //     viewBtn: this.vaildData(this.permission.systemtype_view, false),
    //     delBtn: this.vaildData(this.permission.systemtype_delete, false),
    //     editBtn: this.vaildData(this.permission.systemtype_edit, false),
    //   };
    // },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    handleClose() {
      this.$emit('closeWindow', true);
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    openSystemTypeDialog() {
      this.onLoad();
      this.openFlag = true;
    },
  },
};
</script>

<style></style>
